import React from "react";

export const ContactData = ({ userDetails }) => {
	return (
		<div className={"flex-grow overflow-y-auto pt-2 sm:pt-8"}>
			<div className={"mb-8"}>
				<p className={"mb-8 sm:text-xl"}>
					Basic details about yourself should already have been set up for you.
					Please check all details and if you need to change them, please go to{" "}
					<span className="uppercase">setup</span> on{" "}
					<span className="uppercase">your to-dos</span> page and find 'Your
					Details' and re-enter.
				</p>
				<div className={"flex-grow"}>
					<dl className={"grid grid-cols-3 gap-2 text-md break-words"}>
						<dt className={"text-right font-bold"}>NHS/CHI No.:</dt>
						<dd className={"text-left col-span-2"}>{userDetails.nhsNo}</dd>
						<dt className={"text-right font-bold"}>Mobile No.:</dt>
						<dd className={"text-left col-span-2"}>
							{userDetails.mobilePhone.trim() || "Not supplied"}
						</dd>
						<dt className={"text-right font-bold"}>Email:</dt>
						<dd className={"text-left col-span-2"}>{userDetails.email}</dd>

						{/* <div className={"col-span-3"}></div> */}

						<dt className={"text-right font-bold"}>First Names:</dt>
						<dd className={"text-left col-span-2"}>{userDetails.firstName}</dd>
						<dt className={"text-right font-bold"}>Surname:</dt>
						<dd className={"text-left col-span-2"}>{userDetails.surname}</dd>
						<dt className={"text-right font-bold"}>Sex:</dt>
						<dd className={"text-left col-span-2"}>{userDetails.sex}</dd>
					</dl>
				</div>
			</div>
		</div>
	);
};
